export * from '@novel-segment/loaders/segment';
import load from '@novel-segment/loaders/segment';

export default load
